import BackButton from './BackButton';

export default BackButton;
export * from './types';
export * from './getBackButtonSearchParams';
export { BackButton };
